import React from "react";
import { Box, Typography, Stack, Link, useTheme, Divider } from "@mui/material";
import VisorDePDF from "../funcionales/popoverPDF";
import { useLanguage } from "../../context/LanguageContext";

export default function Educacion({ id }) {
  const theme = useTheme();
  const { language } = useLanguage();

  const textsEducacion = {
    es: {
      titulo: "Educación",
      carrera:
        "Tecnólogo en Análisis y Desarrollo de Sistemas de Información (ADSI) – SENA",
      descripcion:
        "Desarrollo web front-end, manejo de bases de datos y aplicaciones de escritorio con C# en .NET.",
      periodo: "Período: 2014 - 2016",
      cursos: "Cursos gratuitos completados en:",
    },
    en: {
      titulo: "Education",
      carrera:
        "Technologist in Analysis and Development of Information Systems (ADSI) – SENA",
      descripcion:
        "Front-end web development, database management, and desktop applications with C# in .NET.",
      periodo: "Period: 2014 - 2016",
      cursos: "Completed free courses at:",
    },
  };

  return (
    <Box
      id={id}
      component="section"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: { xs: 3, sm: 4, md: 6 },
        backgroundColor: "transparent",
        color: theme.palette.text.primary,
        transition: "background-color 0.3s ease, color 0.3s ease",
      }}
    >
      <Box data-aos="fade-right" sx={{ maxWidth: "800px", width: "100%" }}>
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontFamily: theme.typography.fontFamily[0],
            fontWeight: 700,
            fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
            background: theme.palette.secondary.main,
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 4,
            textTransform: "uppercase",
          }}
        >
          {textsEducacion[language].titulo}
        </Typography>

        <Stack spacing={2} alignItems="center" sx={{ mb: 5 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {textsEducacion[language].carrera}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.text.secondary, maxWidth: 700 }}
          >
            {textsEducacion[language].descripcion}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: theme.palette.text.disabled }}
          >
            {textsEducacion[language].periodo}
          </Typography>

          <VisorDePDF archivo="SENA" />
        </Stack>

        <Divider sx={{ my: 4, maxWidth: "400px", mx: "auto" }} />

        <Stack spacing={2} alignItems="center">
          <Typography variant="body1">
            {textsEducacion[language].cursos}
            <Link
              href="https://www.codecademy.com/profiles/Hernan_Gomez"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{
                fontWeight: 600,
                color: theme.palette.secondary.main,
                "&:hover": {
                  color: theme.palette.error.main,
                },
              }}
            >
              Codecademy
            </Link>
          </Typography>
          <VisorDePDF archivo="CodeCademy" />
        </Stack>
      </Box>
    </Box>
  );
}
